<template>
  <div class="px-5 pt-2.5 pb-5 bg-white rounded-sm">
    <CruiseDetailCommenTitle v-if="showTitle" title="当前位置" />
    <div class="h-[521px] relative z-1">
      <TMap
        class="w-full h-full relative"
        :center="center"
        @loaded="onMapLoaded"
      >
        <L7Marker :key="cruise_id" :lnglat="center">
          <div
            v-if="!showRoute"
            :style="{
              width: '40px',
              height: '80px',
            }"
          >
            <img
              class="w-full h-full"
              :src="cruiseIcon.url"
              :style="{
                transform: `rotate(${rotation}deg)`,
              }"
            />

            <div
              class="w-[68px] h-17 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
            >
              <el-image
                class="w-[68px] h-17"
                src="~/assets/img/cruise-map/icon-ship-active.png"
              />
              <div
                class="el-popover el-popper absolute transform !right-0 translate-x-full !top-1/2 -translate-y-1/2 -mr-5"
                x-placement="right"
              >
                <div
                  class="popper__arrow !top-1/2 transform -translate-y-1/2"
                />
                <div>
                  <el-image
                    class="w-[60px] h-[22px]"
                    fit="contain"
                    :src="logo"
                    v-if="logo"
                  />
                  <div class="flex items-center mt-2">
                    <el-image
                      class="w-6 h-4 mr-[5px]"
                      fit="contain"
                      :src="flag"
                      v-if="flag"
                    />
                    <div class="text-dark text-lg font-semibold">
                      {{ name }}
                    </div>
                  </div>
                  <div class="text-xs text-[#B6B6B6] mt-1" v-if="en_name">
                    {{ en_name }}
                  </div>
                  <div
                    class="text-xs fomt-semibold mt-2 text-[#62676D] whitespace-nowrap"
                    v-if="navistatus_label"
                  >
                    航行状态：{{ navistatus_label }}
                  </div>
                  <div
                    class="text-xs fomt-semibold mt-1 text-[#62676D] whitespace-nowrap"
                    v-if="update_time"
                  >
                    更新时间：{{ update_time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </L7Marker>
        <CruiseShipTrajectory
          v-if="showRoute"
          :sourceData="lineSourceData"
          :points="points"
        />
      </TMap>
      <template v-if="hasLocation">
        <div class="absolute z-10 right-[20px] bottom-[90px] shadow">
          <div
            class="flex flex-col items-center justify-center w-[48px] h-[48px] p-1 bg-white first:rounded-t-lg last:rounded-b-lg transition-colors active:bg-gray-50 select-none"
          >
            <el-switch size="mini" :width="30" v-model="showRoute" />
            <span class="text-xs mt-0.5">轨迹</span>
          </div>
        </div>
        <div
          v-show="showRoute"
          class="date_picker absolute z-10 left-[10px] top-[10px] flex items-center"
        >
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            class="!w-[280px]"
            @change="onDateChange"
          >
          </el-date-picker>
        </div>
      </template>
      <div class="map_mask" v-if="!hasLocation"></div>
    </div>
    <ul class="list-none flex text-[#3D3D3D] text-[15px] pt-6 px-10 flex-wrap">
      <li class="w-1/4 mb-1">MMSI：{{ aisInfo.mmsi }}</li>
      <li class="w-1/4 mb-1">船首向：{{ aisInfo.hdg }}</li>
      <li class="w-1/4 mb-1">风速：{{ aisInfo.windspeed }}</li>
      <li class="w-1/4 mb-1">风向：{{ aisInfo.winddir }}</li>
      <li class="w-1/4 mb-1">IMO：{{ aisInfo.imo }}</li>
      <li class="w-1/4 mb-1">航向：{{ aisInfo.cog }}</li>
      <li class="w-1/4 mb-1">浪高：{{ aisInfo.waveheight }}</li>
      <li class="w-1/4 mb-1">涌高：{{ aisInfo.swellheight }}</li>
      <li class="w-1/4 mb-1">呼号：{{ aisInfo.callsign }}</li>
      <li class="w-1/4 mb-1">航速：{{ aisInfo.sog }}</li>
      <li class="w-1/4 mb-1">涌向：{{ aisInfo.swelldir }}</li>
      <li class="w-1/4 mb-1">涌周期：{{ aisInfo.swellperiod }}</li>
      <li class="w-1/4 mb-1">状态：{{ aisInfo.navistatus }}</li>
      <li class="w-1/4 mb-1">纬度：{{ aisInfo.lat }}</li>
      <li class="w-1/4 mb-1">温度：{{ aisInfo.temperature }}</li>
      <li class="w-1/4 mb-1">湿度：{{ aisInfo.humidity }}</li>
      <li class="w-1/4 mb-1">吃水：{{ aisInfo.draught }}</li>
      <li class="w-1/4 mb-1">经度：{{ aisInfo.lon }}</li>
      <li class="w-1/4 mb-1">气压：{{ aisInfo.pressure }}</li>
      <li class="w-1/4 mb-1">能见度：{{ aisInfo.visibility }}</li>
    </ul>
  </div>
</template>
<script>
import ICON_SHIP_SELECT from "assets/img/cruise-map/icon-ship-selected.png";
import ICON_SHIP from "assets/img/cruise-map/icon-ship.png";
import { toNumber } from "lodash";
import CruiseMapMask from "~/components/cruise-map/cruise-map-mask.vue";
import defineAsyncComponent from "~/utils/defineAsyncComponent";

import { REQUEST_CODES } from "@/constants/const-http";
import { getAisCruiseTrajectory } from "@/services/company";
import CruiseDetailCommenTitle
  from "@/views/company/CruiseDetailCommenTitle.vue";
import {
  computed,
  defineComponent,
  ref,
} from "@nuxtjs/composition-api";
import { useAsyncState } from "@vueuse/core";
import { useToggle } from "@vueuse/shared";

export default defineComponent({
  name: "CruiseDetailMap",
  components: {
    CruiseDetailCommenTitle,
    // CruiseMapContent,
    CruiseMapContentNew: defineAsyncComponent(() =>
      import("@/views/cruise-map/cruise-map-content-new.vue")
    ),

    TMap: defineAsyncComponent(() => import("@/components/l7-map/map.vue")),
    CruiseShipTrajectory: defineAsyncComponent(() =>
      import("@/views/company/CruiseShipTrajectory.vue")
    ),
    CruiseMapMask,

    L7Marker: defineAsyncComponent(() =>
      import("@/components/l7-map/marker.vue")
    ),
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    code: String,
    cog: [Number, String],
    name: String,
    en_name: String,
    latitude: [Number, String],
    longitude: [Number, String],
    flag: String,
    logo: String,
    cruise_id: String,
    navistatus_label: String,
    update_time: String,
    aisInfo: {
      type: Object,
      default: () => ({
        mmsi: "",
        imo: "",
        callsign: "", //呼号
        navistatus: "", //状态
        draught: "", // 吃水
        hdg: "", //船首
        lon: "", //经度文本展示
        longitude: "", //经度
        latitude: "", // 纬度
        lat: "", //维度文本展示
        sog: "", //航速
        cog: "", //航向
        humidity: "", //湿度
        pressure: "", //气压
        swelldir: "", //涌向
        swellheight: "", //涌高
        swellperiod: "", //涌周期
        temperature: "", //温度
        visibility: "", //能见度
        waveheight: "", //浪高
        winddir: "", //风向
        windspeed: "", //风速
      }),
    },
  },
  setup(props) {
    const [showPopover, toggleShowPopover] = useToggle(true);
    const dateRange = ref([]);
    const { execute, state: points } = useAsyncState(
      async () => {
        const { code, data, msg } = await getAisCruiseTrajectory({
          id: props.cruise_id,
          time_start: dateRange.value[0] || "",
          time_end: dateRange.value[1] || "",
        });
        if (code !== REQUEST_CODES.ERROR_OK) {
          throw new Error(msg);
        }
        return data;
      },
      [],
      {
        onError: (e) => {
          console.error(e);
        },
      }
    );

    const showRoute = ref(false);
    const showTrajectory = ref(false);
    const onDateChange = async (date) => {
      if (date) {
        dateRange.value = date;
      } else {
        dateRange.value = [];
      }
      await execute(0);
    };
    const lineSourceData = computed(() => {
      if (!points.value) {
        return [];
      }

      const lineData = points.value.map((item) => {
        return [item.longitude, item.latitude];
      });
      return [
        {
          coordinates: lineData,
        },
      ];
    });
    // const dateSourceData = computed(() => {
    //   if (!cruiseData.value) {
    //     return [];
    //   }
    //   return featureCollection(
    //     cruiseData.value.map((item) => {
    //       return createPoint([item.longitude * 1, item.latitude * 1], {
    //         text: item.create_time,
    //       });
    //     })
    //   );
    // });
    const center = ref([props.longitude, props.latitude]);
    const cruiseIcon = computed(() => {
      return {
        url: showPopover.value ? ICON_SHIP_SELECT : ICON_SHIP,
        size: { width: 40, height: 80 },
      };
    });

    const onMapLoaded = (scene) => {
      scene.setCenter(center.value);
    };
    return {
      //船角度需要过滤内容中的度文字
      rotation: computed(() => toNumber(props.cog.replace("度", "")) || 0),
      center,
      cruiseIcon,
      // bmapRef,
      points,

      // showRoute,
      // trajectorySearchData,
      // lineLayerRef,
      // labelLayerRef,
      // onLineLayerReday,
      // onLabelLayerReday,
      dateRange,
      showRoute,

      showPopover,
      toggleShowPopover,

      onMapLoaded,

      // dateSourceData,
      lineSourceData,
      onDateChange,
    };
  },
  computed: {
    hasLocation() {
      return !!(this.latitude && this.longitude);
      // return false
    },
  },
  methods: {
    draw({ el, BMap, map }) {
      console.log({ el, BMap, map });

      // const pixel = map.pointToOverlayPixel(
      // 	new BMap.Point(this.longitude, this.latitude)
      // );
      // el.style.left = pixel.x - 34 + "px";
      // el.style.top = pixel.y - 34 + "px";
    },
    onClick() {
      // const route = this.$router.resolve({
      // 	path: '/cruise-map',
      // 	query: {
      // 		cruiseId: this.$route.params.cruiseId
      // 	}
      // })
      // window.open(route.href, '_blank');
    },
    async onIconClick() {
      this.$nextTick(() => {
        if (this.showPopover) {
          return;
        }
        console.log("onIconClick");
        this.toggleShowPopover(true);
      });
    },
  },
});
</script>
<style lang="scss" scoped>
.date_picker ::v-deep .el-range-separator {
  width: auto;
}
.map_mask {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background: rgba(0, 0, 0, 0.45);
}
.map_mask::before {
  content: "暂无定位信息";
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  font-size: 15px;
  line-height: 1;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  pointer-events: none;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.closeBtn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 9999px;
  height: 1.75rem;
  position: absolute;
  right: -1rem;
  top: -1rem;
  width: 1.75rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
}
.closeBtn:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
</style>
